import { render, staticRenderFns } from "./quotation-contacts.vue?vue&type=template&id=d60539e2&scoped=true&"
import script from "./quotation-contacts.vue?vue&type=script&lang=js&"
export * from "./quotation-contacts.vue?vue&type=script&lang=js&"
import style0 from "./quotation-contacts.vue?vue&type=style&index=0&id=d60539e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60539e2",
  null
  
)

export default component.exports